module.exports = __webpack_public_path__ + "static/media/round_1.f773bee6.png";